// extracted by mini-css-extract-plugin
export default {"app":"E8ecAx9l","van-popup--bottom":"AV2FhSVy"};